<template>
  <div>
    <h1 v-if="$_.isEmpty(widget)">
      Configure Pickups Table Widget
    </h1>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Title"
            prop="title"
          >
            <el-input
              v-model="form.title"
              placeholder="Title of the widget"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Status"
            prop="status"
          >
            <el-select
              v-model="form.status"
              placeholder="Status"
              class="w-100"
              multiple
            >
              <el-option
                v-for="status in statuses"
                :key="status"
                :label="$filters.titleize(status)"
                :value="status"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Type"
            prop="type"
          >
            <el-select
              v-model="form.type"
              placeholder="Type"
              class="w-100"
              multiple
            >
              <el-option
                v-for="type in types"
                :key="type"
                :label="$filters.titleize(type)"
                :value="type"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    widget: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        title: 'Pickups Table',
        type: ['permanent', 'auto', 'adhoc'],
        status: ['held', 'error']
      },
      statuses: ['shipper', 'hidden', 'cancelled', 'held', 'error', 'pending', 'processing', 'processed', 'confirmed'],
      types: ['permanent', 'auto', 'adhoc', 'scheduled'],
      isResizable: true,
      rules: {
        title: [
          { required: true, message: 'Title of widget is required', trigger: 'blur' }
        ],
        status: [
          { required: true, message: 'Status of pickups is required', trigger: 'change' }
        ],
        type: [
          { required: true, message: 'Type of pickups is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    if (!this.$_.isEmpty(this.widget)) {
      const configuration = this.widget[Object.keys(this.widget)[0]].configuration
      this.form = Object.assign(this.form, configuration)
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let widget = this.getFormattedWidget()
          if (!this.$_.isEmpty(this.widget)) { // Editing existing widget
            const widgetI = Object.keys(this.widget)[0]
            this.$emit('submitted', { [widgetI]: Object.assign({}, this.widget[widgetI], widget) })
          } else { // Creating new widget
            this.$emit('submitted', widget)
          }
        }
      })
    },
    getFormattedWidget () {
      return {
        name: 'Pickups Table',
        configuration: {
          title: this.form.title,
          status: this.form.status,
          type: this.form.type,
          isResizable: this.isResizable
        }
      }
    }
  }
}
</script>
